// Disabled in this file because we need assertions in this complex library code.
// The tests assure us that the return types are correct.
/* eslint-disable @typescript-eslint/consistent-type-assertions */

/**
 * Given a GraphQL type, return a new GraphQL type with all `__typename` fields stripped from it.
 */
// Complexity disabled because this is library code that's necessarily complex.
// eslint-disable-next-line complexity
export function withoutTypenames<T>(originalObject: T): WithoutTypenames<T> {
  if (originalObject === null || typeof originalObject !== "object") {
    return originalObject as unknown as WithoutTypenames<T>;
  }

  if (Array.isArray(originalObject)) {
    return originalObject.map(
      withoutTypenames
    ) as unknown as WithoutTypenames<T>;
  }

  const newObject: Record<string, any> = { ...originalObject };
  for (const key of Object.keys(newObject)) {
    if (key === "__typename") {
      delete newObject[key];
    } else if (Array.isArray(newObject[key])) {
      newObject[key] = newObject[key].map(withoutTypenames);
    } else if (typeof newObject[key] === "object") {
      newObject[key] = withoutTypenames(newObject[key]);
    }
  }

  return newObject as unknown as WithoutTypenames<T>;
}

type WithoutTypenames<T> = T extends readonly any[]
  ? WithoutTypenames<T[number]>[]
  : T extends number | string | null | undefined | boolean | Date
  ? T
  : T extends {}
  ? Omit<T, "__typename">
  : T;
